//# sourceMappingURL=block_processing.mjs.map
/// <reference types="./block_processing.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $html from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $html_parser from "../../common/html_parser.mjs";
import * as $document_context from "../../data/docx/document_context.mjs";
import * as $kind from "../../data/docx/kind.mjs";
import * as $decrypt from "../../decrypt.mjs";
import { Ok, Error, toList, prepend as listPrepend, CustomType as $CustomType } from "../../gleam.mjs";

export class BlockProcessing extends $CustomType {
  constructor(doc_context, html_tag, metadata) {
    super();
    this.doc_context = doc_context;
    this.html_tag = html_tag;
    this.metadata = metadata;
  }
}
export const BlockProcessing$BlockProcessing = (doc_context, html_tag, metadata) =>
  new BlockProcessing(doc_context, html_tag, metadata);
export const BlockProcessing$isBlockProcessing = (value) =>
  value instanceof BlockProcessing;
export const BlockProcessing$BlockProcessing$doc_context = (value) =>
  value.doc_context;
export const BlockProcessing$BlockProcessing$0 = (value) => value.doc_context;
export const BlockProcessing$BlockProcessing$html_tag = (value) =>
  value.html_tag;
export const BlockProcessing$BlockProcessing$1 = (value) => value.html_tag;
export const BlockProcessing$BlockProcessing$metadata = (value) =>
  value.metadata;
export const BlockProcessing$BlockProcessing$2 = (value) => value.metadata;

export class Metadata extends $CustomType {
  constructor(kind) {
    super();
    this.kind = kind;
  }
}
export const Metadata$Metadata = (kind) => new Metadata(kind);
export const Metadata$isMetadata = (value) => value instanceof Metadata;
export const Metadata$Metadata$kind = (value) => value.kind;
export const Metadata$Metadata$0 = (value) => value.kind;

function metadata_decoder() {
  return $decrypt.optional_field(
    "kind",
    $kind.decoder(),
    (kind) => { return $decode.success(new Metadata(kind)); },
  );
}

export function decoder() {
  return $decode.field(
    "doc_context",
    $document_context.decoder(),
    (doc_context) => {
      return $decrypt.optional_field(
        "html_tag",
        $decode.string,
        (html_tag) => {
          let html_tag$1 = $option.unwrap(html_tag, "");
          return $decrypt.optional_field(
            "metadata",
            metadata_decoder(),
            (metadata) => {
              let metadata$1 = $option.unwrap(
                metadata,
                new Metadata(new None()),
              );
              return $decode.success(
                new BlockProcessing(doc_context, html_tag$1, metadata$1),
              );
            },
          );
        },
      );
    },
  );
}

export function to_html(block_processing) {
  let node = (_capture) => {
    return $html.element("steerlab-block-processing", _capture, toList([]));
  };
  let doc_context_attrs = $document_context.to_html_attributes(
    block_processing.doc_context,
  );
  let class$ = $a.class$("block-processing-placeholder");
  let editable = $a.content_editable(false);
  return node(listPrepend(class$, listPrepend(editable, doc_context_attrs)));
}

export function encode(block_processing) {
  return $json.object(
    toList([
      ["type", $json.string("block_processing")],
      ["doc_context", $document_context.encode(block_processing.doc_context)],
      ["html_tag", $json.string(block_processing.html_tag)],
      ["metadata", $json.object(toList([]))],
    ]),
  );
}

export function from_html(html) {
  let _block;
  let _pipe = $string.trim(html);
  _block = $string.starts_with(_pipe, "<steerlab-block-processing");
  let is_block_processing = _block;
  return $bool.guard(
    !is_block_processing,
    new Error(undefined),
    () => {
      let root = $html_parser.as_tree(html);
      let doc_context = $document_context.from_html_attributes(root);
      return new Ok(
        new BlockProcessing(doc_context, "", new Metadata(new $option.None())),
      );
    },
  );
}

export function update_kind(processing, kind) {
  let metadata = new Metadata(new Some(kind));
  return new BlockProcessing(
    processing.doc_context,
    processing.html_tag,
    metadata,
  );
}
